var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScootIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 7H19.1052L20.8697 16.7043C22.4449 17.0457 23.625 18.4476 23.625 20.125C23.625 22.058 22.0581 23.625 20.125 23.625C18.1919 23.625 16.625 22.058 16.625 20.125C16.625 19.9499 16.6378 19.7777 16.6627 19.6094L16.0826 20.125H10.5C10.5 22.058 8.93299 23.625 7 23.625C5.06701 23.625 3.5 22.058 3.5 20.125C3.5 18.1919 5.06701 16.625 7 16.625C8.2955 16.625 9.4266 17.3288 10.0318 18.375H11.2647C10.8762 16.8654 9.50586 15.75 7.875 15.75H3.5V14H7.875C10.4764 14 12.6358 15.892 13.0524 18.375H15.4173L18.8413 15.3314L17.6448 8.75H15.75V7ZM8.75 20.125C8.75 21.0915 7.9665 21.875 7 21.875C6.0335 21.875 5.25 21.0915 5.25 20.125C5.25 19.1585 6.0335 18.375 7 18.375C7.9665 18.375 8.75 19.1585 8.75 20.125ZM21.875 20.125C21.875 21.0915 21.0915 21.875 20.125 21.875C19.1585 21.875 18.375 21.0915 18.375 20.125C18.375 19.1585 19.1585 18.375 20.125 18.375C21.0915 18.375 21.875 19.1585 21.875 20.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScootIcon);
export default __webpack_public_path__ + "static/media/scootIcon.0487b77f6591148724259b871cd918c2.svg";
export { ForwardRef as ReactComponent };